import React from 'react';
import { Text } from 'atoms/Text/Text';
import { defaultTheme } from 'constants/theme/defaultTheme';
import { Button } from 'atoms/Button/Button';
import { Styles } from './styles';
import VTailDarkLogo from 'assets/svgs/vTailDarkLogo.svg';

export type DesktopFooterProps = {
  onClick: () => void;
};

export const DesktopFooter = ({ onClick }: DesktopFooterProps) => {
  return (
    <Styles.Footer>
      <Styles.Content>
        <Styles.LeftHandSide>
          <Styles.Logo>
            <VTailDarkLogo />
          </Styles.Logo>
          <Styles.CompanyDetails>
            <Text.h1 color={defaultTheme.colors.white}>vTail</Text.h1>
            <Text.h3 regular color={defaultTheme.colors.white}>
              Instant access to all of the product information you need
            </Text.h3>
          </Styles.CompanyDetails>
        </Styles.LeftHandSide>
        <Styles.RightHandSide>
          <Button onClick={onClick} medium block text="Sign up now" />
        </Styles.RightHandSide>
      </Styles.Content>
    </Styles.Footer>
  );
};
